import { createAction } from "redux-actions";

export const enablePortraitViewMessage = createAction('ENABLE_PORTRAIT_VIEW_MESSAGE');
export const disablePortraitViewMessage = createAction('DISABLE_PORTRAIT_VIEW_MESSAGE');



// WEBPACK FOOTER //
// ./src/redux/portraitViewMessageActions.js